import * as React from "react";
import { TestResults } from "./PFTAPITypes";
import { DynamicResultsGroupHeading } from "./ResultsGroupHeading";

export interface TestCommentsCount {
    id: string;
    count: number;
}

export interface FixedCommentsSelectorsProps {
    testResults: Array<TestResults>;
    selectedTestCommentsCount: Array<TestCommentsCount>;
    selectedSessionCommentsCount: number;
    onTestFixedCommentClick: (testId: string) => void;
    onSessionFixedCommentClick: () => void;
    addCommentsSuffix: boolean;
}

export const FixedCommentsSelectors = ({
    testResults,
    selectedTestCommentsCount,
    selectedSessionCommentsCount,
    onTestFixedCommentClick,
    onSessionFixedCommentClick,
    addCommentsSuffix
}: FixedCommentsSelectorsProps) => {
    return (
        <>
            <DynamicResultsGroupHeading resultsCount={testResults.length} title="Comments" />
            <tr>
                <td>{addCommentsSuffix ? "Over-reading Comments" : "Over-reading"}</td>
                {testResults.map(tr => {
                    return (
                        <td key={`FixedCommentsButton${tr.TestId}`}>
                            <button
                                data-automationid={`open-test-fixed-comments-${tr.TestNumber}`}
                                className="btn btn-primary"
                                onClick={() => onTestFixedCommentClick(tr.TestId)}>
                                Open&nbsp;
                                <span className="badge badge-info">
                                    {selectedTestCommentsCount.length > 0 ? selectedTestCommentsCount.find(x => x.id == tr.TestId).count : null}
                                </span>
                            </button>
                        </td>
                    );
                })}
                <td>
                    <button className="btn btn-primary" data-automationid="open-session-fixed-comments" onClick={() => onSessionFixedCommentClick()}>
                        Open&nbsp;
                        <span className="badge badge-info">{selectedSessionCommentsCount}</span>
                    </button>
                </td>
            </tr>
        </>
    );
};
